define('collections/resellers',['require','collections/base','models/reseller'],function(require){

    var BaseCollection = require('collections/base');
    var Model = require("models/reseller");

    return BaseCollection.extend({
        model: Model,
        url: 'resellers.json',
        parse: function(response) {
            return response.results;
          }
    });
});

